const PhoneIcon = ({
  scale,
  color,
  style,
}: {
  scale?: number;
  color?: string;
  style?: React.CSSProperties;
}) => {
  let c = "#424242";
  if (color) c = color;

  return (
    <svg
      style={{ transform: `scale(${scale || 1})` }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="vuesax/linear/call-calling">
        <g id="call-calling">
          <g id="call-calling_2">
            <path
              id="Vector"
              d="M1.69134 15.275C1.69134 15.575 1.75801 15.8834 1.89967 16.1834C2.04134 16.4834 2.22467 16.7667 2.46634 17.0334C2.87467 17.4834 3.32467 17.8084 3.83301 18.0167C4.33301 18.225 4.87467 18.3334 5.45801 18.3334C6.30801 18.3334 7.21634 18.1334 8.17467 17.725C9.13301 17.3167 10.0913 16.7667 11.0413 16.075C11.9997 15.375 12.908 14.6 13.7747 13.7417C14.633 12.875 15.408 11.9667 16.0997 11.0167C16.783 10.0667 17.333 9.11669 17.733 8.17502C18.133 7.22502 18.333 6.31669 18.333 5.45002C18.333 4.88335 18.233 4.34169 18.033 3.84169C17.833 3.33335 17.5163 2.86669 17.0747 2.45002C16.5413 1.92502 15.958 1.66669 15.3413 1.66669C15.108 1.66669 14.8747 1.71669 14.6663 1.81669C14.4497 1.91669 14.258 2.06669 14.108 2.28335L12.1747 5.00835C12.0247 5.21669 11.9163 5.40835 11.8413 5.59169C11.7663 5.76669 11.7247 5.94169 11.7247 6.10002C11.7247 6.30002 11.783 6.50002 11.8997 6.69169C12.008 6.88335 12.1663 7.08335 12.3663 7.28335L12.9997 7.94169C13.0913 8.03335 13.133 8.14169 13.133 8.27502C13.133 8.34169 13.1247 8.40002 13.108 8.46669C13.083 8.53335 13.058 8.58335 13.0413 8.63335C12.8913 8.90835 12.633 9.26669 12.2663 9.70002C11.8913 10.1334 11.4913 10.575 11.058 11.0167C10.608 11.4584 10.1747 11.8667 9.73301 12.2417C9.29967 12.6084 8.94134 12.8584 8.65801 13.0084C8.61634 13.025 8.56634 13.05 8.50801 13.075C8.44134 13.1 8.37467 13.1084 8.29967 13.1084C8.15801 13.1084 8.04967 13.0584 7.95801 12.9667L7.32467 12.3417C7.11634 12.1334 6.91634 11.975 6.72467 11.875C6.53301 11.7584 6.34134 11.7 6.13301 11.7C5.97467 11.7 5.80801 11.7334 5.62467 11.8084C5.44134 11.8834 5.24967 11.9917 5.04134 12.1334L2.28301 14.0917C2.06634 14.2417 1.91634 14.4167 1.82467 14.625C1.74134 14.8334 1.69134 15.0417 1.69134 15.275Z"
              stroke={c}
              strokeMiterlimit="10"
            />
            <path
              id="Vector_2"
              d="M4.58333 7.50004C4.58333 7.00004 4.975 6.23337 5.55833 5.60837C6.09167 5.03337 6.8 4.58337 7.5 4.58337"
              stroke={c}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector_3"
              d="M1.66667 7.50002C1.66667 4.27502 4.275 1.66669 7.5 1.66669"
              stroke={c}
              stroke-linecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default PhoneIcon;
